import { render, staticRenderFns } from "./DialogReview.vue?vue&type=template&id=6e4bc56e&"
import script from "./DialogReview.vue?vue&type=script&lang=js&"
export * from "./DialogReview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports